exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb{\r\n  margin-top:10px;\r\n}\r\nbody{\r\n  font-family: roboto;\r\n}\r\nh6{\r\n  text-align: center;\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color:#007B85;\r\n}\r\np{\r\n  text-align: center;\r\n  font-size:15px;\r\n  color:black;\r\n}\r\n.panel-default{\r\n  box-shadow: 2px 2px 2px 2px #C0C0C0;\r\n  min-height:170px;\r\n  border:1px solid #007B85;\r\n}\r\n.panel-default:hover{\r\n\tbox-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);\r\n}\r\na{\r\n  text-decoration: none;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/telco-audit-trail/telco-audit-trail.component.css
// module id = 478
// module chunks = 1